import React, { useState, useEffect } from "react";
import { HeaderIconSvg } from '../../images/Svgs'
import Logo from '../../images/logo.png'
import User from '../../images/user.jpg'
import { AdminLogout } from "../../utils/Utils";
import { useNavigate } from "react-router-dom";
const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
	const navigate = useNavigate();
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const UserName = JSON.parse(localStorage.getItem('userDetail'));
	const toggleMenu = (event) => {
		event.preventDefault();
		setIsMenuOpen((prev) => !prev);
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (!event.target.closest('.nav-item.dropdown')) {
				setIsMenuOpen(false);
			}
		};

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	return (
		<header className="meal-plan-header">
			<nav className="navbar navbar-expand-lg">
				<div className="container-fluid">
					<a className="navbar-brand" ><img src={Logo} onClick={() => navigate('/dashboard')} alt="" /></a>
					<button className="navbar-toggler" type="button" data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
						aria-expanded="false" aria-label="Toggle navigation">
						<i className="fa-solid fa-bars"></i>
					</button>
					<div className="collapse navbar-collapse show" id="navbarSupportedContent">
						<ul className="navbar-nav mb-2 mb-lg-0">
							<li className="nav-item">
								<a className="nav-link" aria-current="page" href="#">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<g id="Iconly/Regular/Two-tone/Notification">
											<g id="Notification">
												<path id="Stroke 1" fill-rule="evenodd" clip-rule="evenodd"
													d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z"
													stroke="black" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
												<path id="Stroke 3" opacity="0.4"
													d="M14.3889 20.8572C13.0247 22.3719 10.8967 22.3899 9.51953 20.8572"
													stroke="black" stroke-width="1.5" stroke-linecap="round"
													stroke-linejoin="round" />
											</g>
										</g>
									</svg>
								</a>
							</li>
							<li className="nav-item dropdown">
								<a className={`nav-link dropdown-toggle ${isMenuOpen ? 'show' : ''}`} href="#" id="navbarDropdown" role="button"
									data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => toggleMenu(e)}>
									<img src={User} />
								</a>
								<ul className={`dropdown-menu ${isMenuOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
									{/* <li><a className="dropdown-item" href="#">Profile</a></li>
								<li><a className="dropdown-item" href="#">Billing & Subscriptions</a></li> */}
									<li><a className="dropdown-item text-capitalize" href="#">{UserName?.first_name} {UserName?.last_name} </a></li>
									<li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => AdminLogout()}>Logout</a></li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</nav>
			<button className="openbtn nav_togglebtn" onClick={() => setIsSidebarOpen(!isSidebarOpen)}><svg width="24" height="24" viewBox="0 0 24 24"
				fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M13 16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H13C13.2652 18 13.5196 17.8946 13.7071 17.7071C13.8946 17.5196 14 17.2652 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16ZM3 8H21C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8ZM21 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z"
					fill="black"></path>
			</svg></button>
		</header>
	)
}
export default Header